module.exports = "<section>\n    update works\n</section>\n\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/invoices/invoice-update/invoice-contract-question/invoice-contract-question.html
// module id = ./web/modern/components/invoices/invoice-update/invoice-contract-question/invoice-contract-question.html
// module chunks = 0